<template>
  <hr class="pa-separator pa-separator-checked-style" />
</template>

<script>
export default {
  
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

hr.pa-separator{
  &-checked-style{
    margin:.5rem 0;
    background-color:$tile-separator-background;
    background-image: url("Images/checked-tile.svg");
    height:2.8rem;

    @include from($tablet) {
      height:60px;
    }
  }
}
</style>